/**
 * AON CRAFT TOOLKIT LOGIN
 *
 */

import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;

import './lib/foundation-explicit-pieces';

//$(document).foundation();
$( '.language-menu-icon, #language_menu' ).foundation();


$(document).ready( function () {
	$( '#language_menu_container' ).show();
    if ( $( '#loginform' ).length > 0 ) {
	   $( '#user_pass' ).attr( 'autocomplete', 'off' );
    }
	updateLanguageSaveButton( $( '.language_selector input[type="radio"]:checked' ) );
});

// Language Selector
function updateLanguageSaveButton( languageRadio ) {
	var langSave = languageRadio.val();
	var saveTranslation = $( '.lang_save_' + langSave ).val();

	if ( saveTranslation ) {
		$( '.language_selector input[type="submit"]' ).val( saveTranslation );
	}
}

$( 'body' ).on( 'change', '.language_selector input[type="radio"]', function() {
	updateLanguageSaveButton( $( this ) );
});
